export const environment = {
  production: true,
  apiHost: 'https://api.newscube.de/api',
  socketHost: 'https://api.newscube.de',
  cdnHost: 'https://cdn.newscube.de',
  exportHost: 'https://export.newscube.de',
  clickHost: 'https://clickbiz.de',
};
